import React, { createContext, useState, useEffect, useContext } from 'react';
import PubSub from 'pubsub-js'
import { useImmer } from 'use-immer';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment';
import { useHistory } from 'react-router';
import { CustomerContext } from '../../contexts/CustomerContext';
import { AuthContext } from '../../contexts/AuthContext';
import { MessageService } from '../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronRight, faChevronLeft, faChevronCircleRight } from "@fortawesome/free-solid-svg-icons"
import ReactPaginate from 'react-paginate';
import ResultCountDisplay from '../../controls/table/ResultCountDisplay';

const formatRead = (text, read) => {
    if (read) {
        return text;
    } else {
        return <b>{text}</b>
    }
}

const limitStringLen = (str, maxLength = 200) => {
    if (str.length > maxLength) {
        let shortStr = str.slice(0, maxLength) + '...';
        return shortStr;
    }
    return str;
}

const formatDate = (date) => {
    const dt = moment(date)
    let returnVal = '';
    const currDate = moment();
    const same = dt.isSame(currDate, 'day');
    if (same) {
        returnVal = dt.format('h:mm A');
    } else {
        const yearSame = dt.isSame(currDate, 'year');
        if (yearSame) {
            returnVal = dt.format('M/D');
        } else {
            returnVal = dt.format('M/D/YY');
        }
    }
    return returnVal;
}

const CustomerMessages = (props) => {

    const [messages, setMessages] = useImmer([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [showAllForAccount, setShowAllForAccount] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(0);
    const _isMounted = React.useRef(false)
    const history = useHistory();
    const context = useContext(CustomerContext);
    const authContext = useContext(AuthContext);



    const getMessages = async () => {
        var queryObject = {};
        queryObject.skip = currentPage * pageSize;
        queryObject.take = pageSize;

        const messageService = new MessageService();
        const callResult = await messageService.getMessages(queryObject);
        if (callResult.result) {
            setMessages(callResult.model.messages);
            setTotalRecords(callResult.model.totalRecords);
        }
    }

    useEffect(() => {
        if (_isMounted.current) {
            getMessages();
        }
    }, [currentPage])

    useEffect(() => {

        getMessages();
        _isMounted.current = true

        return () => {
            _isMounted.current = false
        }
    }, [])

    const handlePage = (page) => {
        const selectedPage = page.selected;
        if (currentPage !== selectedPage) {
            setCurrentPage(selectedPage);
        }
        window.scrollTo(0, 0);
    }

    const messageCreatedCallback = () => {
        getMessages();
    }

    const showCreateMessageModal = () => {
        const initModel = {
            sentFromUserId: authContext.currentUser.id,
            accountId: parseInt(authContext.getClaim(authContext.claims.accountId)),
            //sentToUserId: 2
        }
        context.showModal({
            open: true,
            size: 'lg',
            model: initModel,
            closeModal: context.hideModal,
            onSaveCallback: messageCreatedCallback,
        }, 'createMessage')
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Messages</div>
                <div className="card-btn-group">
                    <Button variant="primary" onClick={() => showCreateMessageModal()} size="sm">New Message</Button>
                </div>
            </Card.Header>
            <Card.Body className="card-body-table">
                {/*<small><pre>{JSON.stringify(messages, null, 2)}</pre></small>*/}
                <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th className="fit-content">Last Update By</th>
                            <th>Subject</th>
                            <th className="fit-content content-align-center">Coding Event</th>
                            <th className="fit-content content-align-right">Last Update On</th>
                            <th className="table-fit"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            messages.map((msg, i) =>
                                <tr key={msg.id}
                                    onClick={() => history.push(`/customer/messages/${msg.id}`)}
                                    className="givemethefinger"
                                //style={msg.read == true ? {} : { "backgroundColor": "rgba(0, 0, 0, 0.1)" }}
                                >
                                    <td className="fit-content">
                                        {formatRead(msg.threadLastUpdatedBy.fullName, true)}<br />
                                        {msg.threadLastUpdatedBy.accountName}
                                    </td>
                                    <td>
                                        {formatRead(msg.subject, true)}<br /><small><i>{limitStringLen(msg.message)}</i></small>
                                    </td>
                                    <td className="fit-content content-align-center">
                                        {msg.codingEventId > 0 ? <FontAwesomeIcon icon={faCheck} className="success-icon" /> : null}
                                    </td>
                                    <td className="fit-content content-align-right">
                                        {formatRead(formatDate(msg.threadLastUpdatedOn), true)}
                                    </td>
                                    <td className="table-fit content-align-right">
                                        <LinkContainer to={`/customer/messages/${msg.id}`}>
                                            <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
                                        </LinkContainer>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                <ResultCountDisplay className="border-top" currentPage={currentPage} pageSize={pageSize} currentResultCount={messages?.length} totalResults={totalRecords} />
                {
                    totalRecords > pageSize ?
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            //padding: 20,
                            boxSizing: 'border-box',
                            width: '100%',
                        }}>
                            <ReactPaginate
                                activeClassName={'pagination-item pagination-active '}
                                breakClassName={'pagination-item pagination-break-me '}
                                breakLabel={'...'}
                                containerClassName={'pagination-pagination'}
                                disabledClassName={'pagination-disabled-page'}
                                marginPagesDisplayed={2}
                                nextClassName={'pagination-item pagination-next '}
                                nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                                onPageChange={handlePage}
                                forcePage={currentPage}
                                pageCount={Math.ceil(totalRecords / pageSize)}
                                pageClassName={'pagination-item pagination-page '}
                                pageRangeDisplayed={2}
                                previousClassName={'pagination-item pagination-previous'}
                                previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                            />
                        </div> : null
                }
            </Card.Body>
        </Card>
    )
}

export default CustomerMessages;